import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IconDefinition, faArrowLeft } from '@fortawesome/pro-light-svg-icons';

import { EnvironmentConfig } from '../../../config/environment.config';

@Component({
  selector: 'mom-header-admin-full-screen',
  templateUrl: './header-admin-full-screen.component.html',
  styleUrls: ['./header-admin-full-screen.component.scss']
})
export class HeaderAdminFullScreenComponent {
  @Input() icon: IconDefinition = faArrowLeft;
  @Input() showLogo: boolean;
  @Output() closePage = new EventEmitter<void>();

  logo = this.environment.logoPath;
  logoAltName = `${this.environment.appName} Logo`;

  constructor(@Inject('environment') private environment: EnvironmentConfig, private router: Router) {}

  goHome(): void {
    this.router.navigate(['home']);
  }
}
